( function() {
     const smoothScroll = () => {
        const navLinks = document.querySelectorAll('.anchor-menu a');

        function smoothScroll(target) {
        document.querySelector(target).scrollIntoView({
            behavior: 'smooth'
        });
        }

        for (let link of navLinks) {
        link.addEventListener('click', (ev) => {
            ev.preventDefault();
            smoothScroll(ev.target.hash);
        });
        }
    }

    document.addEventListener("DOMContentLoaded", () => {
        smoothScroll();
    });
}() );